<div *ngIf="!hideFooter" class="footer text-center py-2">
  <div class="d-flex gap-2 justify-content-center">
    <div>
      <a class="footer-brand" href="https://evento.sa/home" target="_blank">
        <img
          class="logo"
          *ngIf="translate.currentLang == 'en'"
          src="assets/images/footer/evento-logo-en.svg"
        />
        <img
          class="logo"
          *ngIf="translate.currentLang == 'ar'"
          src="assets/images/footer/evento-logo.svg"
        />
      </a>
      <span
        class="px-2"
        style="color: #718096; font-weight: bold; font-size: 14px"
        >Powered By</span
      >
    </div>
    <a routerLink="/vat">
      <img alt="vat" src="assets/images/footer/vat.svg" />
    </a>
  </div>
</div>
